import InputGroup from "../../../../components/FormComponent/InputGroup";
import Layout from "../../../../components/Layout";
import BreadCrumb from "../../../../components/BreadCrumb";
import { useState, useEffect, useMemo } from "react";
import { httprequest } from "../../../../data/api";
import Flutterwave from "../../../../assets/images/flutterwave.jpeg";
import PayStack from "../../../../assets/images/paystack.jpeg";
import PayPal from "../../../../assets/images/paypal.jpeg";
import Stripe from "../../../../assets/images/stripe.png";
import Remita from "../../../../assets/images/remita.png";
import { toast } from "react-toastify";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import { StructureType } from "../../../../utils/DropDown";
import Select from "react-select";
import TextAreaGroup from "../../../../components/FormComponent/TextAreaGroup";
import Button from "../../../../components/Button";
import useStyles from "../../styles";
import { Icon } from "@iconify/react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper,
  Grid
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import useValidator from "../../../../hooks/useValidator";
import Modal from "../../../../components/Modal";
import PageLoader from "../../../../components/PageLoader";
import { useUserState } from "../../../../context/UserContext";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const ALL_STUDENT = "/api/v1/students";
const ADMIN_CLASS_ENDPOINT = "/api/v1/class";
const CLASS_SUBJECT_ENDPOINT = "/api/v1/class-subject/";
const SCH_ITEM = "/api/v1/fee-item";
const SCH_INTEGRATION = "/api/v1/integrations/school";
const INTEGRATIONS = "/api/v1/integrations";
const INVOICE_ENDPOINT = "/api/v1/invoices";
const ALL_INVOICES = "/api/v1/invoices";
const SCHOOL_DISCOUNTS = "/api/v1/discounts";

const EditInvoice = () => {
  const { id } = useParams();
  const { profile } = useUserState();
  const [activeSession, setActiveSession] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [isGettingDiscounts, setIsGettingDiscounts] = useState(false);
  const [discountModal, setDiscountModal] = useState(false);
  const [discountItems, setDiscountItems] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [allstudent, setAllStudent] = useState([]);
  const [invoiceItem, setInvoiceItem] = useState([]);
  const [classData, setClassData] = useState([]);
  const [paymentIntegration, setPaymentIntegration] = useState([]);
  const [invoiceValidator, showInvoiceValidator] = useValidator();
  const [isSaving, setIsSaving] = useState(false);
  const [isSending, setisSending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editInvoiceData, setEditinvoiceData] = useState([]);
  const [gettingSubject, setGettingSubject] = useState(false);
  const classes = useStyles();
  const [currency, setCurrency] = useState([]);
  const navigate = useNavigate();
  const [cancelModal, setCancelModal] = useState(false);
  const [isGettingCurrency, setIsgettingCurrency] = useState(false);
  const [editrows, setEditRows] = useState([
    { item_id: "", amount: "" }
  ]);

  const [editInvoiceForm, setEditnvoiceForm] = useState({
    invoice_name: "",
    structure_type: "",
    // class_id: [],
    term_id: "",
    // subject_id: "",
    // student_id: "",
    invoice_items: [],
    // payment_method: [],
    due_date: "",
    description: "",
    total: ""
  });

  /**
 * Closes the cancel confirmation modal
 * @function handleCloseCancelModal
 */
  const handleCloseCancelModal = () => {
    setCancelModal(false);
  };

  /**
 * Toggles the cancel confirmation modal
 * @function handleCancelModal
 */
  const handleCancelModal = () => {
    setCancelModal(!cancelModal);
  };

  /**
     * Fetches all invoice items from the server.
     * @function
     * @description Makes a GET request to SCHOOL_DISCOUNTS endpoint and updates the invoice items state.
     */
  const getAllDiscounts = () => {
    setIsGettingDiscounts(true);
    httprequest
      .get(SCHOOL_DISCOUNTS)
      .then((res) => {
        setDiscountItems(res?.data?.data);
        setIsGettingDiscounts(false);
      }).catch((err) => {
        setIsGettingDiscounts(true);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Parses a custom date string into YYYY-MM-DD format
 * @function parseCustomDate
 * @param {string} dateString - Date string in format "DD Month, YYYY"
 * @returns {string} Formatted date in YYYY-MM-DD or empty string if invalid
 */
  const parseCustomDate = (dateString) => {
    if (!dateString) return "";

    const months = {
      January: "01", February: "02", March: "03", April: "04",
      May: "05", June: "06", July: "07", August: "08",
      September: "09", October: "10", November: "11", December: "12"
    };

    const parts = dateString.split(" ");
    if (parts.length !== 3) return "";

    const day = parts[0].padStart(2, "0");
    const month = months[parts[1].replace(",", "")];
    const year = parts[2];

    return `${year}-${month}-${day}`;
  };

  /**
 * Calculates the total invoice amount from items
 * @function totalAmount
 * @type {number}
 * @memo
 * @listens editInvoiceForm.invoice_items
 */
  const totalAmount = useMemo(() => {
    return editInvoiceForm?.invoice_items?.reduce(
      (sum, row) => sum + (parseFloat(row?.amount) || 0),
      0
    );
  }, [editInvoiceForm.invoice_items]);

  const handleDiscountModal = () => {
    setDiscountModal(!discountModal);
  };

  /**
 * Formats the total amount with commas for display
 * @function getFormattedTotal
 * @returns {string} Formatted currency string
 */
  const getFormattedTotal = () => {
    // return new Intl.NumberFormat("en-US").format(totalAmount || 0);
    const discountPercentage = selectedDiscount?.value || 0;

    // Calculate discounted amount
    const discountAmount = totalAmount * (discountPercentage / 100);
    const discountedTotal = totalAmount - discountAmount;

    return new Intl.NumberFormat("en-US").format(discountedTotal);
  };

  /**
 * Fetches subjects for a specific class
 * @function getAllSubjectForClass
 * @async
 * @param {string} class_value - The class ID to fetch subjects for
 */
  const getAllSubjectForClass = async (class_value) => {
    setGettingSubject(true);
    try {
      const res = await httprequest.get(`${CLASS_SUBJECT_ENDPOINT}${class_value}`);
      setAllClassSubject(res?.data?.data);
      setGettingSubject(false);
    } catch (err) {
      setGettingSubject(false);
      toast.error(err?.response?.data);
    }
  };

  /**
 * Fetches a single invoice for editing
 * @function getAnInvoice
 * @async
 */
  const getAnInvoice = () => {
    setIsLoading(true);
    httprequest
      .get(`${ALL_INVOICES}/${id}`)
      .then((res) => {
        const editData = res?.data?.data;
        setEditinvoiceData(editData);
        setEditnvoiceForm({
          ...editInvoiceForm,
          invoice_name: editData?.invoice_name,
          provider_id: editData?.provider_id,
          discount_id: editData?.discount_id,
          currency: editData?.currency,
          structure_type: editData?.structure_type,
          term_id: editData?.term?.id,
          status: editData?.status,
          invoice_items: editData?.fee_items?.map(item => ({
            item_id: item?.id,
            amount: item?.amount
          })),
          bank_accounts: editData?.offline_payment_methods?.map(payment => payment?.id) || [],
          due_date: editData?.due_date,
          description: editData?.description,
          student_id: editData?.student?.id,
          subject_id: editData?.subject?.id || "",
          class_id: editData?.classes?.map(cls => cls?.id) || [],
          total: editData?.total
        });
        // setEditRows(
        //   editData.fee_items?.map(item => ({
        //     item_id: item?.id,
        //     amount: item?.amount
        //   }))
        // );
        if (editData?.classes?.length > 0) {
          const value = editData?.classes[0]?.id;
          if (value) {
            getAllSubjectForClass(value);
          }
        }
        if (editData?.payment_method?.length > 0) {
          const firstProvider = editData?.payment_method?.[0]?.provider;
          if (firstProvider) {
            setIsgettingCurrency(true);
            httprequest.get(`${INTEGRATIONS}/${firstProvider}/currencies`).then((res) => {
              setCurrency(res?.data?.data);
              setIsgettingCurrency(false);
            });
          }
        }
        setIsLoading(false);
        // setSearchResult(res?.data?.data);
      }).catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data);
      });
  };

  /**
 * Handles sending the edited invoice
 * @function handleSendInvoice
 * @async
 */
  const handleSendInvoice = () => {
    setisSending(true);
    if (editInvoiceForm?.structure_type === "class") {
      delete editInvoiceForm.student_id;
      delete editInvoiceForm.subject_id;
    } else if (editInvoiceForm?.structure_type === "subject") {
      delete editInvoiceForm.student_id;
    } else if (editInvoiceForm?.structure_type === "student") {
      delete editInvoiceForm.subject_id;
    }

    if (invoiceValidator.allValid()) {
      setisSending(true);
      httprequest
        .patch(`${INVOICE_ENDPOINT}/${id}`, { ...editInvoiceForm, status: "sent" })
        .then(() => {
          toast.success("Invoice sent successfully");
          navigate("/payment/invoice");
          setisSending(false);
        })
        .catch((err) => {
          setisSending(false);
          toast.error(err?.response?.data);
        });
    } else {
      setisSending(false);
      showInvoiceValidator(true);
    }
  };

  const handleBankAccountChange = (event, bankId) => {
    const isChecked = event.target.checked;

    setEditnvoiceForm((prevForm) => {
      const currentBankAccounts = new Set(prevForm?.bank_accounts || []);

      if (isChecked) {
        currentBankAccounts?.add(bankId);
      } else {
        currentBankAccounts?.delete(bankId);
      }

      return {
        ...prevForm,
        bank_accounts: Array?.from(currentBankAccounts)
      };
    });
  };

  /**
 * Handles saving the edited invoice as draft
 * @function handleSaveInvoice
 * @async
 */
  const handleSaveInvoice = () => {
    setIsSaving(true);
    if (editInvoiceForm?.structure_type === "class") {
      delete editInvoiceForm.student_id;
      delete editInvoiceForm.subject_id;
    } else if (editInvoiceForm?.structure_type === "subject") {
      delete editInvoiceForm.student_id;
    } else if (editInvoiceForm?.structure_type === "student") {
      delete editInvoiceForm.subject_id;
    }

    if (invoiceValidator.allValid()) {
      setIsSaving(true);
      httprequest
        .patch(`${INVOICE_ENDPOINT}/${id}`, { ...editInvoiceForm, status: "saved" })
        .then(() => {
          toast.success("Invoice Saved Successfully");
          navigate("/payment/invoice");
          setIsSaving(false);
        })
        .catch((err) => {
          setIsSaving(false);
          toast.error(err?.response?.data);
        });
    } else {
      setIsSaving(false);
      showInvoiceValidator(true);
    }
  };

  /**
 * Handles payment provider selection change
 * @function handleRadioChange
 * @param {string} providerId - The payment provider ID
 * @param {string} providerName - The payment provider name
 */
  const handleRadioChange = (providerId, providerName) => {
    const isCurrentlySelected = editInvoiceForm?.provider_id === providerId;

    if (isCurrentlySelected) {
      // Unselect if currently selected
      setEditnvoiceForm((prevForm) => ({
        ...prevForm,
        provider_id: ""
      }));
      setCurrency([]);
      setIsgettingCurrency(false);
    } else {
      // Select new provider
      setEditnvoiceForm((prevForm) => ({
        ...prevForm,
        provider_id: providerId
      }));
      setIsgettingCurrency(true);
      httprequest.get(`${INTEGRATIONS}/${providerName}/currencies`).then((res) => {
        setCurrency(res?.data?.data);
        setIsgettingCurrency(false);
      });
    }
  };

  /**
 * Handles currency selection change
 * @function handleCurrencyChange
 * @param {Object} e - The change event
 */
  const handleCurrencyChange = (e) => {
    const curr = e.target.value;

    setEditnvoiceForm({
      ...editInvoiceForm,
      currency: curr
    });
  };

  /**
 * Fetches all terms for a specific session
 * @function getAllTerms
 * @param {string} Session_ID - The session ID to filter terms
 */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
   * Get All Payment
   */
  const getAllPaymentMethod = () => {
    httprequest
      .get(SCH_INTEGRATION)
      .then((res) => {
        setPaymentIntegration(res?.data?.data?.filter((int) => int?.category?.toLowerCase() === "payment"));
      });
    // .catch(() => {});
  };

  /**
   * Get All Invoice Item
   */
  const getAllInvoiceItem = () => {
    httprequest
      .get(SCH_ITEM)
      .then((res) => {
        setInvoiceItem(res?.data?.data);
      });
  };

  /**
   * Handle Get All Students
   */
  const getAllStudents = async () => {
    try {
      const res = await httprequest.get(ALL_STUDENT);
      setAllStudent(res?.data?.data?.map((a_student) => ({
        value: a_student?.student?.id,
        label: `${a_student?.student?.last_name} ${a_student?.student?.first_name}`
      })));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
   * Get all classes as a school admin
   */
  const getAllAdminClasses = () => {
    httprequest
      .get(ADMIN_CLASS_ENDPOINT)
      .then((res) => {
        setClassData(
          res?.data?.data?.map((a_class) => ({
            value: a_class?.id,
            label: a_class?.class_name
          }))
        );
      }).catch(() => {});
  };
  /**
   * Handle Get All Session
   */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * Adds a new item row to the invoice
 * @function addItemRow
 */
  const addItemRow = () => {
    const newRow = { item_id: "", amount: "" };
    setEditnvoiceForm((prevForm) => {
      const updatedRows = [...(prevForm?.invoice_items || []), newRow];

      return {
        ...prevForm,
        invoice_items: updatedRows
      };
    });
  };

  /**
 * Handles changes to invoice item fields
 * @function handleChange
 * @param {Object} e - The change event
 * @param {number} index - The index of the item being edited
 */
  const handleChange = (e, index) => {
    const { name, value } = e.target;

    setEditnvoiceForm((prevForm) => {
      const updatedRows = prevForm?.invoice_items ? [...prevForm.invoice_items] : [];

      // Ensure the row exists before updating
      if (!updatedRows[index]) {
        return prevForm; // Prevent errors by returning the existing state
      }

      updatedRows[index] = { ...updatedRows[index], [name]: value };

      return {
        ...prevForm,
        invoice_items: updatedRows
      };
    });
  };

  /**
 * Deletes an item from the invoice
 * @function handleDelete
 * @param {number} index - The index of the item to delete
 */
  const handleDelete = (index) => {
    const updatedRows = editrows.filter((_, i) => i !== index);
    setEditRows(updatedRows);

    setEditnvoiceForm((prevForm) => ({
      ...prevForm, invoice_items: updatedRows
    }));
  };

  /**
   * Find Active Term in an Current Session
   */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
   * Handle Session Change
   */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  /**
   * Handle Term Change
   * params {Object} event - The change event from the select input
   */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    setEditnvoiceForm({ ...editInvoiceForm, term_id: selectedTermId });
  };

  const removeDiscount = () => {
    setSelectedDiscount(null);
    setEditnvoiceForm(prevState => {
      const updatedState = { ...prevState };
      delete updatedState?.discount_id;

      return updatedState;
    });
  };

  /**
   * handle Invoice Input Change
   * @param {Object} e - The change event from the input field
   */
  // const handleInvoiceInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setEditnvoiceForm({ ...editInvoiceForm, [name]: value });
  // };
  const handleInvoiceInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "discount_id" && value) {
      const discount = discountItems.find(d => d.id === value);
      if (discount) {
        setSelectedDiscount(discount);
        setEditnvoiceForm(prevState => ({
          ...prevState,
          discount_id: value
        }));
        handleDiscountModal();
      }
    } else {
    // Forother input changes
      setEditnvoiceForm(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  /**
 * Handles invoice structure type change
 * @function handleTypeChange
 * @param {Object} e - The change event
 */
  const handleTypeChange = (e) => {
    const type = e.target.value;

    // setStructureType(type);
    setEditnvoiceForm({ ...editInvoiceForm, structure_type: type });
  };

  /**
   * Handle Class Change
   * @param {*} e - The change event from the select input
   */
  const handleClassChange = (e) => {
    const { name, value } = e.target;
    setEditnvoiceForm({ ...editInvoiceForm, [name]: [value] });
    getAllSubjectForClass(value);
  };

  /**
   *
   * Handle Student Select CHange
   */
  const handleSingleStudentChange = (selectedOption) => {
    setEditnvoiceForm({ ...editInvoiceForm, student_id: selectedOption?.value || "" });
  };

  /**
   * Handle Class Change and Get Subject for their respective Classes
   * @param {*} selectedOptions
   */
  const handleMultipleClassChange = async (selectedOptions) => {
    // Extract selected class ids as strings
    const selectedValues = selectedOptions.map((option) => option?.value);

    // Fetch and update subjects for all selected classes
    setEditnvoiceForm({ ...editInvoiceForm, class_id: selectedValues });
  };
  /**
 * Initial data loading on component mount
 * @effect
 */
  useEffect(() => {
    getAllSessions();
    getAllTerms();
    getAllAdminClasses();
    getAllStudents();
    getAllInvoiceItem();
    getAnInvoice();
    getAllPaymentMethod();
    getAllDiscounts();
  }, []);

  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
      setEditnvoiceForm({ ...editInvoiceForm, term_id: active_term_session?.id });
    }
  }, [active_term_session]);

  // get Class if it exist
  // useEffect(() => {
  //   if (editInvoiceForm?.class_id?.length > 0) {
  //     const value = editInvoiceForm?.class_id[0];
  //     if (value) {
  //       getAllSubjectForClass(value);
  //     }
  //   }
  // }, [editInvoiceForm]);

  // useEffect(() => {
  //   if (editInvoiceData?.payment_method?.length > 0) {
  //     const firstProvider = editInvoiceData?.payment_method?.[0]?.provider;
  //     if (firstProvider) {
  //       setIsgettingCurrency(true);
  //       httprequest.get(`${INTEGRATIONS}/${firstProvider}/currencies`).then((res) => {
  //         setCurrency(res?.data?.data);
  //         setIsgettingCurrency(false);
  //       });
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb link_one="/payment/overview" link_one_name="Payments" active="Edit Invoice" description="Create student payment invoices." />
          </div>
        </div>
        <div className="page-content padding-equal">
          {isLoading ? (
            <PageLoader />
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Invoice Name"
                    margin="normal"
                    inputType="text"
                    inputName="invoice_name"
                    defaultValue={editInvoiceForm?.invoice_name}
                    placeHolder="Enter Name"
                    onChange={handleInvoiceInputChange}
                    required
                  />
                  {invoiceValidator.message("Invoice Name", editInvoiceForm?.invoice_name, "required")}
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  {activeSession?.id && (
                    <SelectGroup
                      label="Session"
                      children={
                        <select
                          defaultValue={activeSession?.id}
                          onChange={handleSessionChange}
                          name="session"
                        >
                          <option value="">---Select---</option>
                          {allSessions?.map((sesh) => {
                            return (
                              <option key={sesh?.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  {active_term_session?.id && (
                    <SelectGroup
                      label="Term"
                      children={
                        <select onChange={handleTermChange} name="term_id" value={aselectedTerm}>
                          <option value="">---Select---</option>
                          {selectedSessionTerms?.map((data) => {
                            return (
                              <option key={data?.id} value={data?.id}>
                                {data?.term}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                  {invoiceValidator.message("Term", editInvoiceForm?.term_id, "required")}
                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12}>
                  <SelectGroup
                    label="Structure Type"
                    children={
                      <select onChange={handleTypeChange} name="structure_type" defaultValue={editInvoiceForm?.structure_type}>
                        <option value="">---Select---</option>
                        {StructureType?.map((structure) => {
                          return (
                            <option key={structure?.key} value={structure?.key}>
                              {structure?.text}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {invoiceValidator.message("Structure Type", editInvoiceForm?.structure_type, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  {editInvoiceForm?.structure_type === "class" ? (
                    <div className="multiple-select">
                      <p>Class</p>
                      <Select isMulti name="class_id"
                        closeMenuOnSelect={false}
                        options={classData}
                        defaultValue={editInvoiceData?.classes?.map(item => ({ label: item?.name, value: item?.id }))}
                        onChange={handleMultipleClassChange}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                      />
                      {invoiceValidator.message("Class", editInvoiceForm?.class_id > 0, "required")}
                    </div>
                  ) : editInvoiceForm?.structure_type === "student" ? (
                    <div className="multiple-select">
                      <p>Student</p>
                      <Select name="student_id"
                        closeMenuOnSelect={false}
                        options={allstudent}
                        defaultValue={allstudent.find(student => student?.value === editInvoiceForm?.student_id) || null}
                        onChange={handleSingleStudentChange}
                        getOptionLabel={(option) => option?.label}
                        getOptionValue={(option) => option?.value}
                      />
                      {invoiceValidator.message("Student", editInvoiceForm?.student_id, "required")}
                    </div>
                    // <SelectGroup
                    //   label="Student"
                    //   children={
                    //     <select onChange={handleInvoiceInputChange} name="student_id" defaultValue={editInvoiceForm?.student_id}>
                    //       <option value="">---Select---</option>
                    //       {allstudent?.map((data) => {
                    //         return (
                    //           <option key={data?.student?.id} value={data?.student?.id}>
                    //             {`${data?.student?.last_name} ${data?.student?.frst_name}`}
                    //           </option>
                    //         );
                    //       })}
                    //     </select>
                    //   }
                    // />
                  ) : editInvoiceForm?.structure_type === "subject" ? (
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        {editInvoiceData?.classes.length > 0 && (
                          <SelectGroup
                            label="Select Class"
                            required
                            children={
                              <select
                                name="class_id"
                                onChange={handleClassChange}
                                defaultValue={editInvoiceData?.classes[0]?.id}
                              >
                                <option value="">--- Select ---</option>
                                {classData?.map((clss) => {
                                  return (
                                    <option key={clss?.value} value={clss?.value}>
                                      {clss?.label}
                                    </option>
                                  );
                                })}
                              </select>
                            }
                          />
                        )}
                        {invoiceValidator.message("Class", editInvoiceForm?.class_id > 0, "required")}
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        {editInvoiceData?.subject?.id && !gettingSubject && (
                          <SelectGroup
                            label="Subject"
                            children={
                              <select onChange={handleInvoiceInputChange} name="subject_id" defaultValue={editInvoiceData?.subject?.id}>
                                <option value="">{gettingSubject ? "please wait" : "--Select--"}</option>
                                {allClassSubject?.map((data) => {
                                  return (
                                    <option key={data?.subject_id} value={data?.subject_id}>
                                      {data?.subject_name}
                                    </option>
                                  );
                                })}
                              </select>
                            }
                          />
                        )}
                        {invoiceValidator.message("Subject", editInvoiceForm?.subject_id, "required")}
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <label className={classes.enterque}>Online Payment Method</label>
                  <Grid container spacing={1} sx={{ marginTop: "2px" }}>
                    {paymentIntegration?.length > 0 ? (
                      paymentIntegration.map((item) => (
                        <Grid item lg={4} md={4} sm={6} xs={12} key={item?.id}>
                          <div
                            onClick={() => handleRadioChange(item?.id, item?.provider)}
                            className="soft-border flex justify-content-between gap-24 text-align-left cursor-pointer"
                          >
                            <div>
                              <img
                                height="23px"
                                src={
                                  item?.provider?.toUpperCase() === "PAYSTACK" ? PayStack :
                                    item?.provider?.toUpperCase() === "PAYPAL" ? PayPal :
                                      item?.provider?.toUpperCase() === "STRIPE" ? Stripe :
                                        item?.provider?.toUpperCase() === "FLUTTERWAVE" ? Flutterwave :
                                          item?.provider?.toUpperCase() === "REMITA" ? Remita :
                                            null
                                }
                                alt="Payment Provider"
                              />
                              <p className="no-margin-block">{item?.provider}</p>
                            </div>
                            <input
                              type="checkbox"
                              checked={editInvoiceForm?.provider_id === item?.id}
                              readOnly
                            />
                          </div>
                        </Grid>
                      ))
                    ) : (
                      <div className={classes.plsintegrate}>
                        <p className="cursor-pointer no-margin-block" onClick={() => navigate("/payment-settings")}>
          Please Add a Payment Integration <ArrowOutwardIcon />
                        </p>
                      </div>
                    )}
                    <Grid item xs={12}>
                      <div className="text-align-left">
                        {invoiceValidator.message(
                          "Payment Method",
                          editInvoiceForm?.provider_id || (editInvoiceForm?.bank_accounts && editInvoiceForm?.bank_accounts.length > 0 ? "has_bank_accounts" : null),
                          "required"
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <label className={classes.enterque}>Offline Payment Method</label>
                  <Grid container spacing={1} sx={{ marginTop: "2px" }}>
                    {profile?.bank_details?.length > 0 ? (
                      profile?.bank_details?.map((item) => (
                        <Grid item lg={4} md={4} sm={6} xs={12} key={item?.id}>
                          <div
                            onClick={() => {
                              const syntheticEvent = {
                                target: {
                                  type: "checkbox",
                                  checked: !editInvoiceForm?.bank_accounts?.includes(item?.id)
                                }
                              };
                              handleBankAccountChange(syntheticEvent, item?.id);
                            }}
                            className={classes.bankCard}
                          >
                            <div className={classes.bankCardContent}>
                              <div className={classes.bankHeader}>
                                <Icon icon="guidance:bank" width="24" height="24" />
                                <p className={classes.bankName}>{item?.bank_name?.toUpperCase()}</p>
                              </div>
                              {item?.is_primary && <span className={classes.primaryBadge}>Primary</span>}
                            </div>
                            <input
                              type="checkbox"
                              checked={editInvoiceForm?.bank_accounts?.includes(item?.id) || false}
                              onChange={(e) => handleBankAccountChange(e, item?.id)}
                            />
                          </div>
                        </Grid>
                      ))
                    ) : (
                      <div className={classes.plsintegrate}>
                        <p className="cursor-pointer no-margin-block">
          No Bank Account added
                        </p>
                      </div>
                    )}
                    <Grid item xs={12}>
                      <div className="text-align-left">
                        {invoiceValidator.message(
                          "Payment Method",
                          editInvoiceForm?.provider_id || (editInvoiceForm?.bank_accounts && editInvoiceForm?.bank_accounts.length > 0 ? "has_bank_accounts" : null),
                          "required"
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Payment Currency"
                    children={
                      (() => {
                        // Merge both data sources and remove duplicates (same logic as Create)
                        const mergedData = [];
                        const seenCurrencies = new Set();

                        // Process currency array (online payments)
                        if (currency?.length) {
                          currency?.forEach(item => {
                            const value = item?.key || item?.currency || item;
                            const label = item?.key || item?.currency || item;

                            if (value && !seenCurrencies?.has(value)) {
                              seenCurrencies?.add(value);
                              mergedData.push({
                                value,
                                label,
                                source: "online"
                              });
                            }
                          });
                        }

                        // Process bank details (profile payments)
                        if (profile?.bank_details?.length) {
                          profile?.bank_details?.forEach(item => {
                            const value = item?.key || item?.currency || item;
                            const label = item?.key || item?.currency || item;

                            if (value && !seenCurrencies.has(value)) {
                              seenCurrencies.add(value);
                              mergedData.push({
                                value,
                                label,
                                source: "bank"
                              });
                            }
                          });
                        }

                        const isOnlinePayment = currency?.length;
                        const selectName = isOnlinePayment ? "structure_type" : "currency";
                        const handleChange = isOnlinePayment ? handleCurrencyChange : handleInvoiceInputChange;
                        const isLoading = isOnlinePayment && isGettingCurrency;

                        return (
                          <select
                            value={editInvoiceForm?.currency || ""}
                            onChange={handleChange}
                            name={selectName}
                          >
                            <option value="">
                              {isLoading ? "Please wait..." : "---Select---"}
                            </option>
                            {mergedData?.map((item, index) => (
                              <option key={`${item?.value}-${index}`} value={item?.value}>
                                {item?.label} {item?.source === "online" ? "(Online)" : "(Bank)"}
                              </option>
                            ))}
                          </select>
                        );
                      })()
                    }
                  />
                  {invoiceValidator.message(
                    "Currency",
                    editInvoiceForm?.currency,
                    "required"
                  )}
                </Grid>
              </Grid>
              <TableContainer component={Paper} style={{ marginBlock: "20px 30px" }}>
                <Table>
                  <TableHead style={{ backgroundColor: "#F9FAFB" }}>
                    <TableRow>
                      <TableCell colSpan={3}>Item</TableCell>
                      {/* <TableCell>Payment Method</TableCell> */}
                      <TableCell>Amount</TableCell>
                      {/* <TableCell>Payment Option</TableCell> */}
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ width: "100%" }}>
                    <>
                      {editInvoiceForm?.invoice_items.length > 0 && editInvoiceForm?.invoice_items?.map((row, index) => (
                        <TableRow key={index}>
                          {/* Select for Item */}
                          <TableCell colSpan={3}>
                            <SelectGroup
                              children={
                                <select onChange={(e) => handleChange(e, index)} name="item_id" defaultValue={row?.item_id}>
                                  <option value="">---Select---</option>
                                  {invoiceItem?.map((data) => {
                                    return (
                                      <option key={data?.id} value={data?.id}>
                                        {data?.item}
                                      </option>
                                    );
                                  })}
                                </select>
                              }
                            />
                            {invoiceValidator.message("Item", editInvoiceForm?.invoice_items[index]?.item_id, "required")}
                          </TableCell>

                          {/* Input for Amount & Currency */}
                          <TableCell>
                            <InputGroup
                              margin="normal"
                              inputType="text"
                              inputName="amount"
                              placeholder="Amount"
                              onChange={(e) => handleChange(e, index)}
                              defaultValue={row?.amount}
                              style={{ maxWidth: "300px", width: "100%" }}
                            />
                            {invoiceValidator.message("Amount", editInvoiceForm?.invoice_items[index]?.amount, "required")}
                          </TableCell>

                          {/* Delete Button */}
                          {editInvoiceForm?.invoice_items?.length > 1 && (
                            <TableCell>
                              <button
                                className="table-action-icon delete-icon"
                                onClick={() => handleDelete(index)}
                              >
                                <Icon icon="mingcute:delete-2-line" />
                              </button>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                      <TableRow>
                        {/* Discount Display Row - Only show if discount is applied */}
                        {(editInvoiceForm?.discount_id || selectedDiscount) && (
                          <TableRow className={classes.discountRow}>
                            <TableCell colSpan={3} className={classes.discountLabel}>
                            Discount Added to Invoice
                            </TableCell>
                            <TableCell className={classes.discountValue}>
                              {selectedDiscount.name || "--/--"} - {selectedDiscount.value || "--/--"}%
                            </TableCell>
                            <TableCell className={classes.discountActions}>
                              <Icon
                                icon="mdi:delete"
                                width="24"
                                height="24"
                                className={classes.deleteIcon}
                                onClick={removeDiscount}
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      </TableRow>
                      {/* Centered Add Item Row */}
                      <TableRow>
                        <TableCell colSpan={5} style={{ textAlign: "center", paddingBlock: "0px" }}>
                          <div className={classes.addItemContainer}>
                            <div className={classes.additem} onClick={addItemRow}>
                              <Icon icon="icons8:plus" width="20" height="30" className={classes.icon} />
                              <p>Add item</p>
                            </div>

                            {/* Apply Discount Button */}
                            {(editInvoiceForm?.structure_type === "student") && (
                              <div className={classes.additem}>
                                <Icon icon="ic:outline-discount" width="20" height="30" className={classes.icon} />
                                <p onClick={handleDiscountModal}>Apply Discount</p>
                              </div>
                            )}
                            {/* <div className={classes.additem}>
                              <Icon icon="ic:outline-discount" width="20" height="30" className={classes.icon} />
                              <p onClick={handleDiscountModal}>Apply Discount</p>
                            </div> */}
                          </div>
                        </TableCell>
                      </TableRow>
                    </>
                  </TableBody>
                  <TableFooter style={{ backgroundColor: "#F9FAFB" }}>
                    <TableRow>
                      <TableCell colSpan={3} style={{ textAlign: "left", fontWeight: "700", fontSize: "14px", padding: "24px" }}>
                        Total
                      </TableCell>
                      <TableCell colSpan={2} style={{ textAlign: "right", fontWeight: "700", fontSize: "18px", padding: "24px" }}>
                        {`${editInvoiceForm?.currency || "NGN"} ${getFormattedTotal()}`}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <TextAreaGroup
                    label="Description"
                    margin="normal"
                    inputType="text"
                    inputName="description"
                    required
                    defaultValue={editInvoiceForm?.description}
                    onChange={handleInvoiceInputChange}
                  />
                  {invoiceValidator.message("Description", editInvoiceForm?.description, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Invoice Due Date"
                    margin="normal"
                    inputType="date"
                    inputName="due_date"
                    inputMin={new Date().toISOString().split("T")[0]}
                    required
                    defaultValue={parseCustomDate(editInvoiceForm?.due_date)}
                    onChange={handleInvoiceInputChange}
                  />
                  {invoiceValidator.message("Due Date", editInvoiceForm?.due_date, "required")}
                </Grid>
              </Grid>
              <div className={`${classes.footerbtn} flex gap-10 justify-content-center align-items-center flex-direction-col-413 margin-top-16 flex-wrap-items`}>
                <Button
                  variant="deleteOutline"
                  buttonSize="medium"
                  color="btndanger"
                  buttonName="Cancel"
                  onClick={handleCancelModal}
                />
                {editInvoiceData?.status === "saved" ? (
                  <>
                    <Button
                      variant="primaryoutline"
                      buttonSize="medium"
                      color="btnfontprimary"
                      buttonName="Save"
                      isLoading={isSaving}
                      onClick={handleSaveInvoice}
                    />
                    <Button
                      variant="primary"
                      buttonSize="medium"
                      color="btndefault"
                      buttonName="Send"
                      isLoading={isSending}
                      onClick={handleSendInvoice}
                    />
                  </>
                ) : null}
              </div>
            </>
          )}
        </div>
        <Modal
          title="Add Discount to Invoice"
          subtitle={
            <div>
                       Select a discount to be added to your Invoice.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Select Discount"
                    children={
                      <select onChange={handleInvoiceInputChange} name="discount_id">
                        <option value="">{isGettingDiscounts ? "Please wait..." : "--Select--"}</option>
                        {discountItems?.map((discount) => {
                          return (
                            <option key={discount?.id} value={discount?.id}>
                              {discount?.name} - {discount?.value}%
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
              </Grid>
            </>
          }
          modalFooter={<></>}
          isopen={discountModal}
          closeModal={handleDiscountModal}
        />
        <Modal
          title="Cancel"
          subtitle={
            <div>
            Are you sure you want to cancel ?
            </div>
          }
          modalContent={<></>}
          modalFooter={
            <>
              <div className="flex gap-10">
                <Button
                  variant="dangeroutline"
                  buttonSize="full"
                  color="btndanger"
                  buttonName="Go Back"
                  onClick={handleCloseCancelModal}
                />
                <Button
                  variant="danger"
                  buttonName="Yes Cancel"
                  buttonSize="full"
                  color="btndefault"
                  onClick={() => navigate("/payment/overview")}
                />
              </div>
            </>
          }
          isopen={cancelModal}
          closeModal={handleCloseCancelModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default EditInvoice;
